import { render, staticRenderFns } from "./CreateEditEmployeeType.vue?vue&type=template&id=4f2e8eaa&scoped=true"
import script from "./CreateEditEmployeeType.vue?vue&type=script&lang=js"
export * from "./CreateEditEmployeeType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f2e8eaa",
  null
  
)

export default component.exports